import PackoutServer from '@packout/api/src/PackoutServer';

export const isValidPackoutServer = (s: PackoutServer | null): boolean => {
  if (!s) {
    return false;
  }

  if (s && s.settings.isMilwaukee) {
    return false;
  }

  return true;
};
